import React from 'react';

import { bem } from 'helpers/class-name';
import Message from 'components/Message';

import SmartRateFaqLinkMessage from '../SmartRateFaqLinkMessage';
import { SMART_RATE_FAQ_IDS } from '../SmartRateFaqs.constants';
import GuaranteedMinimumDetailCard from './GuaranteedMinimumDetailCard';
import GuaranteedMinimumPayoutBar from './GuaranteedMinimumPayoutBar';
import GuaranteedMinimumScheduleIllustration from './GuaranteedMinimumScheduleIllustration';
import messages from './GuaranteedMinimumPanel.messages';
import SmartRateTopicPanelLayout from './SmartRateTopicPanelLayout';
import './GuaranteedMinimumPanel.scss';

const { element } = bem('guaranteed-minimum-panel');

const GuaranteedMinimumPanel = () => (
  <SmartRateTopicPanelLayout
    summaryBody={<Message as="p" message={messages.summaryBody} />}
    summaryHeading={messages.summaryHeading}>
    <div className={element('detail-cards')}>
      <GuaranteedMinimumDetailCard
        badgeNumber={1}
        illustration={
          <div className={element('detail-illustration')}>
            <GuaranteedMinimumPayoutBar />
          </div>
        }>
        <Message as="p" message={messages.rateFloorCopy} />
      </GuaranteedMinimumDetailCard>
      <GuaranteedMinimumDetailCard
        badgeNumber={2}
        illustration={
          <div className={element('detail-illustration')}>
            <GuaranteedMinimumScheduleIllustration />
          </div>
        }>
        <SmartRateFaqLinkMessage
          as="p"
          faqId={SMART_RATE_FAQ_IDS.CLASSPASS_CREDITS}
          linkClassName={element('faq-link')}
          message={messages.creditsListingCopyWithLink}
          messageWithoutLink={messages.creditsListingCopy}
        />
      </GuaranteedMinimumDetailCard>
    </div>
  </SmartRateTopicPanelLayout>
);

export default GuaranteedMinimumPanel;
